import gql from 'graphql-tag'

export default gql`
query searchOrderId($orderId: String!) {
  labels(
    sort: _ID_DESC
    filter: {
      referenceId: $orderId
    }
  ) {
    _id
    referenceId
    seq
    last
    data
    recipient
    address
    app
    group
    tracking {
      _id
      carrier
      code
      sendHook
      scannedAt
      status
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/graphql/queries/searchOrderId.js